import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { getContext, initDataDogRum } from '@paypalcorp/cms-engine/client';
import createCache from '@emotion/cache';
import { AppProps } from '@paypalcorp/cms-engine';
import App from './App';

initDataDogRum();

const { renderContext } = getContext(window);

/**
 * When prepend: true, emotion styles are injected right after opening of head tag and its styles
 * are overridden by component stylesheets. To avoid that prepend is modified to false. Reference - https://emotion.sh/docs/@emotion/cache#prepend
 */
const emotionCache = createCache({
  key: 'ppcmsnodeweb',
  prepend: false,
});

hydrateRoot(
  document.getElementById('root') as HTMLElement,
  <App
    emotionCache={emotionCache}
    renderContext={renderContext as AppProps}
  />,
);
